var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04829 0.988264C5.33092 1.29108 5.31455 1.76567 5.01174 2.04829C3.94716 3.04498 2.88214 4.08991 1.99282 5.25L11.2499 5.25C11.6641 5.25 12 5.58579 12 6C12 6.41422 11.6636 6.75 11.2494 6.75L1.99282 6.75C2.88255 7.91062 3.94491 8.95288 5.01174 9.95171C5.31455 10.2343 5.33092 10.7089 5.04829 11.0117C4.76567 11.3146 4.29095 11.3308 3.98814 11.0482C2.82876 9.96558 1.68998 8.84706 0.735937 7.575C0.401403 7.12896 -2.54987e-07 6.58342 -2.29485e-07 6C-2.03983e-07 5.41658 0.401403 4.87105 0.735937 4.425C1.68424 3.1606 2.83912 2.03082 3.98826 0.951712C4.29107 0.669086 4.76567 0.685451 5.04829 0.988264Z",
    fill: "#454A67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackArrow);
export default __webpack_public_path__ + "static/media/iconBackArrow.8e4d142591156c42875db7d4142f911e.svg";
export { ForwardRef as ReactComponent };